import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../media/images/icons/location-fill";
import { addCommas } from "@persian-tools/persian-tools";
import ArrowUpFillSVG from "../../../../../media/images/icons/arrow-up";
import CustomButton from "../../../../components/CustomButton";
import { ITenderOffer } from "..";
import EditTenderOfferModal from "../EditTenderOfferModal";
import { convertToJalali } from "../../../../../utils/functions";
import TenderDeatailsModal from "./TenderDeatailsModal";
import { blueGrey, grey } from "@mui/material/colors";

export default function TenderOfferCard(props: ITenderOffer) {
  const {
    price,
    insertDate,
    id,
    orderId,
    destName,
    goodsName,
    status,
    handleDeleteTender,
    handleEditPrice,
    fare,
  } = props;
  const theme = useTheme();

  const [editTenderOfferModal, setEditTenderOfferModal] = useState(false);

  const [tenderDeatailsModal, setTenderDeatailsModal] = useState(false);

  return (
    <>
      <EditTenderOfferModal
        open={editTenderOfferModal}
        handleClose={() => setEditTenderOfferModal(false)}
      />
      <TenderDeatailsModal
        open={tenderDeatailsModal}
        setOpen={() => setTenderDeatailsModal(false)}
        handleEditPrice={handleEditPrice}
        handleDeleteTender={handleDeleteTender}
        orderId={orderId}
        id={id}
        status={status}
        price={price}
      />
      <Box
        sx={{
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          border: "1px solid",
          borderColor: blueGrey[100],
          gap: "8px",
          borderRadius: "10px",
          flexDirection: "column",
          padding: "8px",
          backgroundColor: "bgColor.white",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "info.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px",
              borderRadius: "8px",
            }}
          >
            <Boxoutline color={theme.palette.textColor.main} />
          </Box>

          <Box
            sx={{
              flex: "1",
              display: "flex",
              gap: "4px",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {goodsName}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "8px",
                  gap: "4px",
                }}
              >
                <Typography
                  color="textColor.main"
                  noWrap
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  کرایه :{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  color="success.main"
                >
                  {addCommas(fare) || "-----"} ریال
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  paddingX: "4px",
                  paddingY: "4px",
                  borderRadius: "6px",
                  backgroundColor: "info.light",
                  gap: "4px",
                }}
              >
                <LocationFill size={18} color={theme.palette.info.dark} />
                <Typography
                  noWrap
                  color="textColor.main"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  {destName}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  borderRadius: "6px",
                  gap: "4px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor:
                      status === 1
                        ? theme.palette.primary[50]
                        : theme.palette.success.light,
                    borderRadius: "5px",
                    paddingX: "4px",
                    paddingY: "4px",
                  }}
                >
                  <Typography
                    color={status === 1 ? "primary.main" : "success.main"}
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    {status === 1 ? "درحال برسی" : "مجوز شده"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "info.light",
                    borderRadius: "5px",
                    paddingX: "4px",
                    paddingY: "4px",
                  }}
                >
                  <Typography
                    color="textColor.main"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    {convertToJalali(insertDate).split(" ")[1]}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            borderColor: "info.dark",
            borderStyle: "dashed",
            borderWidth: "1px",
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.palette.primary[50],
            paddingY: "8px",
            gap: "4px",
            borderRadius: "8px",
          }}
        >
          <ArrowUpFillSVG color={theme.palette.primary.main} />
          <Typography
            sx={{
              color: grey[800],
              fontSize: "14px",
            }}
          >
            کرایه پیشنهادی شما:
          </Typography>
          <Typography color="primary.main">{addCommas(price)} ریال</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
          }}
        >
          {/* <CustomButton
            type="outlined"
            rippleColor={theme.palette.info.dark}
            flex={1}
            // loading
            flexDirection="row-reverse"
            justifyContent="center"
            onClick={() => setEditTenderOfferModal(false)}
            title="ویرایش سریع"
            bgColor={blueGrey[50]}
            textColor="info.dark"
            borderColor="info.dark"
            px="10px"
            py="12px"
            borderRadius="6px"
            icon1={<EditFillSVG size={18} color={blueGrey[400]} />}
          /> */}
          <CustomButton
            flex={1}
            // loading
            onClick={() => setTenderDeatailsModal(true)}
            title="جزئیات بار و ویرایش"
            justifyContent="center"
            bgColor="primary.main"
            textColor="#fff"
            px="10px"
            py="12px"
            borderRadius="6px"
            // icon2={<ArrowTickLeft size={16} color={"#fff"} />}
          />
        </Box>
      </Box>
    </>
  );
}
